import React, { cloneElement, useRef } from 'react'
import PropTypes from 'prop-types'

// Assets
import ArrowDownIcon from 'assets/images/arrowDown'

// Utils
// import { useOutsideAlerter } from 'common/utils/outsideAlerter'

// Styled Elements
import {
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButtonWrapper,
  AccordionItemButtonInnerWrapper,
  AccordionItemButtonInner,
  AccordionItemButtonExpandIcon,
  AccordionItemPanelWrapper,
} from './AccordionTableItem.elements'

function AccordionTableItem(props) {
  // Destructure
  const { button, panel, withExpandIcon, expandIcon, setIsExpanded, expandPanel } = props

  const wrapperRef = useRef()

  // TODO ADD THIS FEATURE BACK BUT NOT AN OUTSIDE ALERTER
  // TODO make the item close only when clicking another item. not on click away
  // useOutsideAlerter(wrapperRef, setIsExpanded)
  // Functions
  const handleExpand = (event) => {
    if (event.target.className?.baseVal && event.target.className?.baseVal === 'hashWrapper') {
      return
    }
    if (typeof event.target.className === 'string' && event.target.className !== '') {
      const classnames = event.target.className.split(' ')
      if (classnames.indexOf('hashWrapper') > -1) {
        return
      }
    }
    setIsExpanded((prevState) => !prevState)
  }

  return (
    <AccordionItem ref={wrapperRef}>
      <AccordionItemHeading onClick={handleExpand}>
        <AccordionItemButtonWrapper expanded={expandPanel ? 1 : 0}>
          <AccordionItemButtonInnerWrapper>
            <AccordionItemButtonInner>{cloneElement(button, { expanded: expandPanel })}</AccordionItemButtonInner>
            <AccordionItemButtonExpandIcon withExpandIcon={withExpandIcon ? 1 : 0} expanded={expandPanel ? 1 : 0}>
              {expandIcon || <ArrowDownIcon />}
            </AccordionItemButtonExpandIcon>
          </AccordionItemButtonInnerWrapper>
        </AccordionItemButtonWrapper>
      </AccordionItemHeading>

      <AccordionItemPanelWrapper expanded={expandPanel ? 1 : 0}>
        {cloneElement(panel, { expanded: expandPanel })}
      </AccordionItemPanelWrapper>
    </AccordionItem>
  )
}

// Default Props
AccordionTableItem.defaultProps = {
  button: '',
  panel: '',
  withExpandIcon: true,
  expandIcon: '',
  expandPanel: false,
}

// Proptypes Validation
AccordionTableItem.propTypes = {
  button: PropTypes.oneOfType([PropTypes.func, PropTypes.string, PropTypes.element, PropTypes.node]),
  panel: PropTypes.oneOfType([PropTypes.func, PropTypes.string, PropTypes.element, PropTypes.node]),
  withExpandIcon: PropTypes.bool,
  expandIcon: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.node]),
  setIsExpanded: PropTypes.func,
  expandPanel: PropTypes.bool,
}

export default AccordionTableItem
